import React, { useEffect } from "react";
import {
  FaUsers,
  FaUserLock,
  FaBoxesStacked,
  FaDollarSign,
  FaFolderTree,
  FaTruckFast,
  FaTags,
} from "react-icons/fa6";
import { FaTimes, FaStoreAlt, FaClipboardList } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import RoutesInterface from "../../interfaces/routesInterface";
import SidebarLink from "./SidebarLink";
import { get } from "local-storage";
import { AuthInterface } from "../../interfaces/authInterface";
import { PermissionsInterface } from "../../interfaces/roleInterface";

type SideBarInterface = {
  open: boolean;
  toggle(): any;
};

const Sidebar = ({ open, toggle }: SideBarInterface) => {
  const location = useLocation();
  const userData = get<AuthInterface>("userData");

  useEffect(() => {
    //console.log("location", location)
  }, [location]);

  const checkIfActive = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  const routes: RoutesInterface[] = [
    {
      route: "users",
      label: "Usuarios",
    },
    {
      route: "roles",
      label: "Roles",
    },
    {
      route: "products",
      label: "Productos",
    },
    {
      route: "shippingCosts",
      label: "Costos de envío",
    },
    {
      route: "distributors",
      label: "Distribuidores",
      key: "dealers",
    },
    {
      route: "promotions",
      label: "Promociones",
    },
    {
      route: "orders",
      label: "Pedidos",
    },
  ];

  const linkIcons: Record<string, React.ElementType> = {
    roles: FaUserLock,
    products: FaBoxesStacked,
    categories: FaFolderTree,
    branches: FaStoreAlt,
    dealers: FaClipboardList,
    orders: FaDollarSign,
    shippingCosts: FaTruckFast,
    promotions: FaTags,
  };

  const getLinkIcon = (route: string, isActive: boolean) => {
    const Icon = linkIcons[route] || FaUsers; // fallback
    return <Icon className={isActive ? "text-sky-500" : "text-white"} />;
  };

  return (
    <div
      className={`md:block bg-slate-600 h-screen w-full md:w-48 fixed z-50 md:relative origin-left overflow-hidden duration-300 md:scale-x-100 ${
        !open ? "transform scale-x-0" : ""
      }`}
    >
      <div className="overflow-y-auto h-full">
        <FaTimes
          className="text-white absolute right-5 top-2 text-xl md:hidden cursor-pointer"
          onClick={toggle}
        />
        <img
          alt="logo"
          src="/img/logos/tt-logo.png"
          className="block m-auto mt-5 mb-2"
        />
        <ul className="px-3">
          {routes.map((r, i) => {
            const routeKey = r.key || r.route;
            const isActive = checkIfActive(r.route);
            const hasAccess =
              userData.role.permissions[routeKey as keyof PermissionsInterface]
                ?.read;
            if (hasAccess) {
              const route =
                routeKey === "shippingCosts" ? "shipping-costs" : r.route;
              return (
                <li onClick={toggle} key={`route-index-${i}`}>
                  <SidebarLink
                    to={route}
                    label={r.label}
                    icon={getLinkIcon(routeKey, isActive)}
                    active={isActive}
                  />
                </li>
              );
            }
            return null;
          })}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
